module.exports = __webpack_public_path__ + "img/list-star.6510cf7a.svg";